import { AlertCircle, CheckCircle2 } from "lucide-react";

import { Card } from "@mantine/core";
import { CreateUserRoleContainerProps } from "pages/settings/create";
import { FC } from "react";
import { FormikProps } from "formik";
import { TextInput } from "components/core";
import _ from "lodash";
import { applicationFeatures } from "_graphql/data/features";
import privileges from "hooks/data/use-privileges";

export interface CreateUserRoleFormProps {
    form: FormikProps<CreateUserRoleContainerProps>;
}

const CreateUserRoleForm: FC<CreateUserRoleFormProps> = ({ form }) => {
    const handlePrivilegeToggle = (privilege: string) => {
        let priv;
        if (form.values.privileges.includes(privilege)) {
            priv = form.values.privileges.filter((p) => p !== privilege);
            form.setFieldValue("privileges", priv);
            return priv;
        } else {
            priv = [...form.values.privileges, privilege];
            form.setFieldValue("privileges", priv);
            return priv;
        }
    };
    return (
        <div className="space-y-6 divide-y divide-gray-200">
            <div>
                <TextInput
                    id="position"
                    label="Position"
                    type="text"
                    placeholder="e.g. CEO"
                    required={true}
                    {...form}
                />
            </div>
            <div className="space-y-6 pt-5">
                <div className="flex items-center justify-between">
                    <div className="block text-sm font-medium text-primary">
                        Privileges <span className="text-red-500">*</span>
                    </div>
                    <div className="flex items-center gap-2 text-sm text-muted-foreground">
                        <AlertCircle className="h-4 w-4" />
                        <span>Critical privileges require admin approval</span>
                    </div>
                </div>

                <div className="space-y-6 mt-2">
                    <div className="border border-gray-300 bg-gray-50 grid grid-cols-2 gap-6 p-6 rounded">
                        {_.map(applicationFeatures, (section) => (
                            <div className="">
                                <span className="block text-sm font-medium text-gray-700">
                                    {_.startCase(section.name)}
                                </span>
                                <div className="mt-1 w-full space-y-1">
                                    {_.map(
                                        section.permissions,
                                        (permission) => (
                                            <div className="relative flex items-start">
                                                <div className="flex h-6 items-center">
                                                    <input
                                                        id={`${permission?.value}.permissions`}
                                                        aria-describedby={`${permission.value}-description`}
                                                        name={`${permission?.value}.permissions`}
                                                        type="checkbox"
                                                        value={permission.value}
                                                        checked={_.includes(
                                                            form?.values
                                                                ?.privileges,
                                                            permission.value
                                                        )}
                                                        onChange={(e) =>
                                                            e.target.checked
                                                                ? form.setFieldValue(
                                                                      "privileges",
                                                                      [
                                                                          ...form
                                                                              ?.values
                                                                              ?.privileges,
                                                                          permission.value,
                                                                      ]
                                                                  )
                                                                : form.setFieldValue(
                                                                      "privileges",
                                                                      _.filter(
                                                                          form
                                                                              ?.values
                                                                              ?.privileges,
                                                                          (
                                                                              perm
                                                                          ) =>
                                                                              perm !=
                                                                              permission.value
                                                                      )
                                                                  )
                                                        }
                                                        className="h-4 w-4 rounded border-gray-300 text-primary-600 focus:ring-primary-600"
                                                    />
                                                </div>
                                                <div className="ml-3 text-sm leading-6">
                                                    <label
                                                        htmlFor={`${permission?.value}.permissions`}
                                                        className="font-medium text-gray-900">
                                                        {permission.name}
                                                    </label>
                                                    {true && (
                                                        <p
                                                            id="candidates-description"
                                                            className="text-gray-500">
                                                            {
                                                                permission.description
                                                            }
                                                        </p>
                                                    )}
                                                </div>
                                            </div>
                                        )
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {form.values.privileges.length > 0 && (
                    <Card className="bg-muted/50">
                        <div className="pb-3">
                            <div className="text-sm font-medium">
                                Selected Privileges Summary
                            </div>
                        </div>
                        <div>
                            <div className="flex flex-wrap gap-2">
                                {form.values.privileges?.map((privilege) => (
                                    <div key={privilege} className="text-xs">
                                        {privilege}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </Card>
                )}
            </div>
        </div>
    );
};

export default CreateUserRoleForm;
